import * as React from 'react';
import { Debounce } from 'react-throttle';
import AccountSubusersRow from './components/AccountSubusersRow';
import AccountClass from 'src/model/account.model';

import './AccountSubusers.scss';

interface IAccountSubusersProps {
  accounts: AccountClass[];
  getAccounts(): void;
  allowModifyInvoices(
    accountId: string,
    clientIdentity: string,
    allow: boolean
  ): void;
}

interface IAccountSubusersState {
  accounts: AccountClass[];
  currentAccounts: AccountClass[];
  searchText: string;
}

class AccountSubusers extends React.Component<
  IAccountSubusersProps,
  IAccountSubusersState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      accounts: [],
      currentAccounts: [],
      searchText: ''
    };
  }

  private handleSearchInputChange = (e: any) => {
    this.setState({ searchText: e.target.value });
    this.handleSearchAccountsChange();
  };

  private handleSearchAccountsChange = () => {
    let results: AccountClass[] = [];
    if (this.state.searchText) {
      results = this.state.accounts.filter(account => {
        return (
          account.name
            .toLowerCase()
            .includes(this.state.searchText.toLowerCase()) ||
          account.email
            .toLowerCase()
            .includes(this.state.searchText.toLowerCase())
        );
      });
    } else {
      results = this.state.accounts;
    }
    this.setState({ currentAccounts: results });
  };

  public componentDidMount() {
    this.setState({
      accounts: this.props.accounts,
      currentAccounts: this.props.accounts
    });
  }

  public componentDidUpdate(prevProps: any) {
    if (prevProps.accounts !== this.props.accounts) {
      this.setState({
        accounts: this.props.accounts,
        currentAccounts: this.props.accounts
      });
    }
  }

  public render() {
    return (
      <div className="rp-account-subusers">
        <div className="rp-account-subusers--header">
          <div className="rp-account-subusers--header-title">
            Manage Subusers
          </div>
          <div className="rp-account-subusers--input-container">
            <Debounce time="500" handler="onChange">
              <input
                className="rp-account-subusers--input"
                placeholder="Search by name or email address"
                onChange={this.handleSearchInputChange}
              />
            </Debounce>
            <button
              className="primary-button rp-account-subusers--button"
              onClick={this.handleSearchAccountsChange}
            >
              <span className="rpds rpds-search" />
            </button>
          </div>
        </div>
        <div className="container-fluid rp-account-subusers-table-header">
          <div className="row">
            <div className="col-2">User ID</div>
            <div className="col-3">Full Name</div>
            <div className="col">Email Address</div>
            <div className="col-2 rp-account-subusers-row--toggle">
              Invoices/Balance
            </div>
          </div>
        </div>
        {this.state.currentAccounts.map(account => (
          <AccountSubusersRow
            userId={account.userId}
            account={account.accountId}
            fullName={account.name}
            email={account.email}
            enabledInvoices={account.hasInvoicePermission}
            manageInvoices={this.props.allowModifyInvoices}
          />
        ))}
      </div>
    );
  }
}

export default AccountSubusers;
